<div *commonUiOptionalWizardStep class="mb-5x">

  <h2 class="mb-3x">{{ 'COMMON_UI.FRAGEBOGEN.UMSAETZE_INTERNET.TITEL' | translate }}</h2>

  <common-ui-umsaetze-internet [(data)]="data" [readonly]="readonly"></common-ui-umsaetze-internet>

</div>
